import { FilterState } from '@/types/filter';

export const RECOMMENDATIONS_SECTION_ID = 'recommendations';

export type SectionId =
  | 'characteristics'
  | 'hcoCharacteristics'
  | 'hcoSegmentations'
  | 'segmentations'
  | 'scientificActivities'
  | typeof RECOMMENDATIONS_SECTION_ID;

export type SectionDraft = Partial<FilterState>;

export type FilterDraft = {
  [key in SectionId]?: SectionDraft;
};

export interface UseSessionStorageDraftReturn {
  getDraft: () => FilterDraft | null;
  getSectionDraft: (sectionId: SectionId) => SectionDraft | null;
  setSectionDraft: (sectionId: SectionId, data: SectionDraft) => void;
  clearSectionDraft: (sectionId: SectionId) => void;
  clearAllDrafts: () => void;
  hasAnySectionWithData: (sectionIds: SectionId[]) => boolean;
  getSectionsWithData: () => SectionId[];
}
